import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row } from '@sm/wds-react';
import SMHeaderContext from '../../../SMHeaderContext';

import './Submenu/nav-submenu.scss';

export const SubMenuBody = ({ children }) => {
  const { lang } = useContext(SMHeaderContext);
  return (
    <Grid noBleeds={lang === 'en'}>
      <Row className="sm-nav-submenu__row">{children}</Row>
    </Grid>
  );
};

SubMenuBody.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SubMenuBody;
